const Views = self => ({
  isGmailUser() {
    return self.integrationId === 5;
  },
});

export default Views;
